var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "right", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInRightBig dx" },
          [
            _c(
              "bar-card",
              { staticClass: "lefts lefts1", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "zxqc" } }, [
                  _vm._v("种畜禽场情况"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("right-cp")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "sygm" } }, [
                  _vm._v("饲养规模情况"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("right-xm")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "syqk" } }, [
                  _vm._v("饲料生产情况"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("right-yz")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }